import MonthlyStatement from './monthly-statements';
import DailyStatement from './daily-statements';
import TransactionHistory from './transaction-history';
import AdvicesStatements from './advices';
import Home from '../income-history/incomeHistoryHome';
import CurrentMonthlyStatement from './current-monthly-statements';
import CorrespondenceStatement from './correspondence-statements';

export default {
  MonthlyStatement,
  DailyStatement,
  TransactionHistory,
  AdvicesStatements,
  Home,
  CurrentMonthlyStatement,
  CorrespondenceStatement,
}
